import {
  selectEntitiesMissionsEntityImageUrl,
  selectEntitiesMissionsEntityLogoUrl,
  selectEntitiesMissionsEntityOperationType,
  selectEntitiesMissionsEntityShowTimer,
} from '../../../../selectors/entities/missions/entitiesMissionsPrimary.selector';
import { Selector } from '../../../../types/selectors';
import { createResultEqualSelector } from '../../../../utils/reselect';
import { MissionOperationType } from '../../types/state/missions';
import { selectUserMissionWonAmount } from '../MissionCard/MissionCard.selector';
import { selectMissionFreebetsPotentialGain } from '../MissionFreebetsPotentialGain/MissionFreebetsPotentialGain.selector';

type MissionDetailsSummaryPropsType = {
  backgroundURL?: string;
  logoURL?: string | null;
  showTimer: boolean;
  wonAmount?: number;
  operationType?: MissionOperationType;
  hasPotentialAmount: boolean;
};

const selectMissionDetailsSummaryProps: Selector<MissionDetailsSummaryPropsType> = createResultEqualSelector(
  [
    selectEntitiesMissionsEntityImageUrl,
    selectEntitiesMissionsEntityLogoUrl,
    selectEntitiesMissionsEntityShowTimer,
    selectUserMissionWonAmount,
    selectEntitiesMissionsEntityOperationType,
    selectMissionFreebetsPotentialGain,
  ],
  (backgroundURL, logoURL, showTimer, wonAmount, operationType, potentialAmount) => ({
    backgroundURL,
    logoURL,
    showTimer,
    wonAmount,
    operationType,
    hasPotentialAmount: !!potentialAmount,
  }),
);

export default selectMissionDetailsSummaryProps;
